export default __webpack_public_path__ + "static/media/litrivia.6488a9af.png";